export default __webpack_public_path__ + "static/media/TKurir.fe2bb2fb.jpg";